import { useUserSettingsStore } from "@bundles/settings/components/user-settings/business"
import { Box, GlobalNavigationItem, Tooltip } from "@tm/components"
import { withRouter } from "@tm/utils"
import { useCallback, useState } from "react"
import PopoverMenu from "./components/menu"

function UsersettingsMenuComponent() {
    const [showMenu, setShowMenu] = useState<boolean>(false)
    const { openUserSettingsDialog, toggleUserSettingsDialog, setScrollTo } = useUserSettingsStore((userSettingsStore) => ({
        openUserSettingsDialog: userSettingsStore.state.openUserSettings,
        toggleUserSettingsDialog: userSettingsStore.actions.setOpenOrToggleUserSettings,
        setScrollTo: userSettingsStore.actions.setScrollTo,
    }))

    function handleButtonClick() {
        setShowMenu(true)
    }

    const handleTooltipHide = useCallback(() => {
        setShowMenu(false)
    }, [setShowMenu])

    const handleOpenUserSettingsAndScroll = useCallback(
        (scrollPosition?: string) => {
            handleTooltipHide()
            toggleUserSettingsDialog()
            setScrollTo(scrollPosition)
        },
        [handleTooltipHide]
    )

    return (
        <Box>
            <Tooltip
                arrow
                placement="bottom"
                onClose={handleTooltipHide}
                onClickAway={handleTooltipHide}
                open={showMenu}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={
                    <Box>
                        <PopoverMenu onClick={handleOpenUserSettingsAndScroll} onClose={handleTooltipHide} />
                    </Box>
                }
                variant="light"
                color="primary"
            >
                <GlobalNavigationItem componentType="icon" name="user" onIconClick={handleButtonClick} active={openUserSettingsDialog} />
            </Tooltip>
        </Box>
    )
}

export default withRouter(UsersettingsMenuComponent)
